/**
 * FloatingDecor — gentle up/down idle animation for decorative pastel orbs
 * or wrapped content. Accepts children for cases like the portrait mask.
 *
 *   <FloatingDecor className="absolute -top-32 -left-24 w-96 h-96 rounded-full bg-roseMilk/60 blur-3xl" />
 *   <FloatingDecor className="..."><img /></FloatingDecor>
 */
import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

export const FloatingDecor = ({
  className,
  range = 12,
  duration = 8,
  ariaHidden = true,
  children,
}) => {
  const reduced = usePreferStaticUI();

  if (reduced) {
    return (
      <div aria-hidden={ariaHidden && !children} className={className}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      aria-hidden={ariaHidden && !children}
      className={className}
      animate={reduced ? undefined : { y: [-range, range, -range] }}
      transition={
        reduced
          ? undefined
          : { duration, ease: "easeInOut", repeat: Infinity }
      }
      style={{ willChange: "transform" }}
    >
      {children}
    </motion.div>
  );
};

export default FloatingDecor;
